import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import careerBuilder from "../../../assets/images/Marketplace/careerbuilder.svg";
import jora from "../../../assets/images/Marketplace/jora.svg";
import linkedin from "../../../assets/images/Marketplace/linkedin.svg";
import monster from "../../../assets/images/Marketplace/monster.svg";
import naukari from "../../../assets/images/Marketplace/naukari.svg";
import shine from "../../../assets/images/Marketplace/shine.svg";
import zipRecruiters from "../../../assets/images/Marketplace/zipRecruiters.svg";
import {
  CardWithButton,
  CustomSearch,
  Divider,
  NewTab,
  showToast,
} from "../../../components";
import { useModuleAccess, usePortalNavigation } from "../../../hooks";
import { getAllIntegrations } from "../../../redux/slices/setting/settingApi";
import { useDispatch, useSelector } from "react-redux";
import { totalCountStart } from "../../../redux/slices/totalCount/totalCountSlice";
import { selectIsAuthenticated } from "../../../redux/slices/auth/authSelectors";
import { getAllIntegrationsBs } from "../../../redux/slices/ats/benchSales/benchSalesApi";
import { getAllIntegrationsNm } from "../../../redux/slices/nonitMarketing/nonitMarketingApi";

const Integration = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);

  const isLogin = useSelector(selectIsAuthenticated);
  const currentUserDetails = useSelector((state) => state.auth.user) || {};
  const { portalValue, getDefaultRouteForCurrentPortal } = usePortalNavigation(
    isLogin,
    currentUserDetails,
  );

  const [checkMultiSelect, setCheckMultiSelect] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [integrations, setIntegrations] = useState({});
  const [buttonLoading, setButtonLoading] = useState(true);

  useEffect(() => {
    setOptions([
      { label: "VOIP", value: 1 },
      { label: "VMS", value: 2 },
      { label: "Job Board", value: 3 },
      { label: "WhatsApp", value: 4 },
      { label: "SMS", value: 5 },
      { label: "AI (Beta)", value: 6 },
      { label: "Productivity", value: 7 },
      { label: "Assessment Tools", value: 8 },
      { label: "Video Interview", value: 9 },
      { label: "Background Check", value: 10 },
      { label: "Bulk Email", value: 11 },
      { label: "Mail Verification", value: 12 },
    ]);

    // Load integrations from localStorage on mount
    const savedIntegrations = localStorage.getItem("marketplace_integrations");
    if (savedIntegrations) {
      setIntegrations(JSON.parse(savedIntegrations));
    }
  }, []);

  const categoryMap = {
    1: "VOIP",
    2: "VMS",
    3: "Job Board",
    4: "WhatsApp",
    5: "SMS",
    6: "AI",
    7: "Productivity",
    8: "Assessment Tools",
    9: "Video Interview",
    10: "Background Check",
    11: "Bulk Email",
    12: "Mail Verification",
  };

  const data = {
    VOIP: [
      {
        type: 1,
        title: "VOIP Office CRM",
        description:
          "Please request the VOIP representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 2,
        title: "ZOOM",
        description:
          "Please request the ZOOM representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 3,
        title: "Unified Voice Call",
        description:
          "Please request the Unified Voice representative to provide the API access with registered name to configure and integrate.",
      },
    ],
    VMS: [
      {
        type: 1,
        title: "Field Glass",
        description:
          "Please request the Monster representative provide the API access with Registered name to configure and....",
      },
    ],
    "Job Board": [
      {
        type: 1,
        title: <img src={monster} alt="Monster Logo" className="w-fit h-8" />,
        description:
          "Please request the Monster representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 2,
        title: <img src={careerBuilder} alt="Career Builder Logo" />,
        description:
          "Please request the Career Builder representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 3,
        title: <img src={shine} alt="Shine Logo" className="w-fit h-8" />,
        description:
          "Please request the Shine representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 4,
        title: <img src={naukari} alt="Naukri Logo" className="w-fit h-8" />,
        description:
          "Please request the Naukri representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 5,
        title: <img src={linkedin} alt="LinkedIn Logo" className="w-fit h-8" />,
        description:
          "Please request the LinkedIn representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 6,
        title: (
          <img
            src={zipRecruiters}
            alt="ZipRecruiter Logo"
            className="w-fit h-8"
          />
        ),
        description:
          "Please request the ZipRecruiter representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 7,
        title: <img src={jora} alt="Jora Logo" className="w-fit h-8" />,
        description:
          "Please request the Jora representative to provide the API access with registered name to configure and integrate.",
      },
    ],
    "Bulk Email": [
      {
        type: 1,
        title: "G-suite (Official)",
        description:
          "Please request the G-suite representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 2,
        title: "Outlook (Official)",
        description:
          "Please request the Outlook representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 3,
        title: "Mailgun",
        description:
          "Please request the Mailgun representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 4,
        title: "AWS SES",
        description:
          "Please request the AWS SES representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 5,
        title: "Instantly",
        description:
          "Please request the Instantly representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 6,
        title: "Send Grid",
        description:
          "Please request the Send Grid representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 7,
        title: "Gmail (Oauth)",
        description:
          "Please login with Oauth using Gmail ID to configure. It will be a one time setup per email ID.",
      },
      {
        type: 8,
        title: "Outlook (Oauth)",
        description:
          "Please login with Oauth using Outlook email ID to configure. It will be a one time setup per email ID.",

      },
    ],
    WhatsApp: [],
    SMS: [],
    AI: [
      {
        type: 1,
        title: "Kult AI (Text)",
        description:
          "Please request the Kult AI representative to provide the API access with registered name to configure and integrate.",
      },
      {
        type: 2,
        title: "Kult AI (Call)",
        description:
          "Please request the Kult AI representative to provide the API access with registered name to configure and integrate.",
      },
    ],
    Productivity: [
      {
        type: 1,
        title: "Google Search API",
        description:
          "Integrate Google Search API for enhanced search capabilities.",
      },
      {
        type: 2,
        title: "Apollo",
        description:
          "Please request the Apollo representative to provide the API access with registered name to configure and integrate.",
      },
    ],
    "Assessment Tools": [],
    "Video Interview": [
      {
        type: 1,
        title: "ZOOM",
        description:
          "Please request the Monster representative to provide the API access with registered name to configure and integrate.",
      },
    ],
    "Background Check": [],
    "Mail Verification": [
      {
        type: 1,
        title: "Valid Email",
        description:
          "Integrate Valid Email API for enhanced mail verification capabilities.",
      },
      {
        type: 2,
        title: "Mailgun",
        description:
          "Integrate Mailgun API for enhanced mail verification capabilities.",
      },
    ],
  };

  const fetchTotalIntegrationsCount = () => {
    if (portalValue === "ats") {
      dispatch(
        totalCountStart({
          collection: "integrations",
          coll: "Integration",
          tname: "allIntegrations",
          app: "ats",
        }),
      );
    } else if (portalValue === "bs") {
      dispatch(
        totalCountStart({
          collection: "integrationbss",
          coll: "Integrationbs",
          tname: "allIntegrationsBs",
          app: "bs",
        }),
      );
    }
  };

  const prepareIntegrationState = (integrationData) => {
    const statusMap = {};

    for (const item of integrationData) {
      const key = `${item.category}-${item.type}`;
      statusMap[key] = item;
    }
    setIntegrations(statusMap);
  };

  const fetchAllINtegrations = async () => {
    const limit =
      portalValue === "bs"
        ? value?.allIntegrationsBs?.data?.total
        : value?.allIntegrations?.data;

    if (limit || limit > 0) {
      const params = {
        coll: portalValue === "bs" ? "Integrationbs" : "Integration",
        // fil: JSON.stringify({ status: { type: "NONE", value: 1 } }),
        lim: limit,
        ret: "uiid category type status addedBy addedOn updatedAt",
      };
      try {
        const allIntegrations =
          portalValue === "bs"
            ? await getAllIntegrationsBs(params)
            : portalValue === "nm"
              ? await getAllIntegrationsNm(params) : await getAllIntegrations(params);
        if (allIntegrations.success) {
          const integrationData = allIntegrations?.data?.data;
          prepareIntegrationState(integrationData);
          setButtonLoading(false);
        } else {
          // showToast("Failed to fetch Integrations", "error");
          setButtonLoading(false);
        }
      } catch (error) {
        // showToast("Failed to fetch Integrations", "error");
        setButtonLoading(false);
      }
    } else {
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    fetchAllINtegrations();
  }, [value?.allIntegrations?.data, value?.allIntegrationsBs]);

  useEffect(() => {
    // checkIntegrationStatus();
    fetchTotalIntegrationsCount();
  }, []);

  const filteredOptions =
    searchValue?.length > 0
      ? options.filter((value) =>
        value["label"].toLowerCase().includes(searchValue.toLowerCase()),
      )
      : options;

  const handleSelect = (optionValue) => {
    let newSelected;
    if (checkMultiSelect.includes(optionValue)) {
      newSelected = checkMultiSelect.filter((v) => v !== optionValue);
    } else {
      newSelected = [...checkMultiSelect, optionValue];
    }
    setCheckMultiSelect(newSelected);
  };

  const handleSelectAll = () => {
    if (checkMultiSelect.length === options.length) {
      setCheckMultiSelect([]);
    } else {
      setCheckMultiSelect(options.map((opt) => opt["value"]));
    }
  };

  const isOptionSelected = (option) =>
    checkMultiSelect.includes(option["value"]);

  const handleSetup = (category, type) => {
    navigate("/marketplace/setup", {
      state: { category, type, showTable: false },
    });
  };

  const handleConfigure = (category, type) => {
    const integrationKey = `${category}-${type}`;
    const integrationData = integrations[integrationKey];

    navigate("/marketplace/setup", {
      state: {
        category,
        type,
        integrationData,
        showTable: true,
      },
    });
  };

  const isIntegrationAdded = (category, type) => {
    // if (category === 6) return false;
    const integrationKey = `${category}-${type}`;
    return !!integrations[integrationKey];
  };

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 flex-1 gap-3 overflow-hidden pb-2 pt-3">
        <div className="border border-gray-100 rounded-md p-2 overflow-auto shadow-sm">
          <div className="mx-2 mt-2">
            <CustomSearch
              placeholder="Search"
              value={searchValue}
              onChange={(key, value) => setSearchValue(value)}
              rounded="rounded-full"
            />
            <Divider className="mt-2" />
          </div>
          <ul className="p-2 space-y-1">
            {searchValue.length === 0 && (
              <li
                className="flex items-center p-2 rounded cursor-pointer hover:bg-primary-50"
                onClick={handleSelectAll}
              >
                <input
                  type="checkbox"
                  checked={checkMultiSelect.length === options.length}
                  readOnly
                  className="mr-2 cursor-pointer appearance-none h-4 w-4 border border-gray-300 rounded-sm flex-shrink-0 checked:bg-primary checked:border-primary checked:after:content-['✓'] 
                      checked:after:text-white checked:after:flex checked:after:items-center checked:after:justify-center checked:after:h-full checked:after:w-full"
                />
                <span>All</span>
              </li>
            )}

            {filteredOptions.map((opt) => (
              <li
                key={opt["value"]}
                className="flex items-center p-2 rounded cursor-pointer hover:bg-primary-50"
                onClick={() => handleSelect(opt["value"])}
              >
                <input
                  type="checkbox"
                  checked={isOptionSelected(opt)}
                  readOnly
                  className="mr-2 cursor-pointer appearance-none h-4 w-4 border border-gray-300 rounded-sm flex-shrink-0 checked:bg-primary checked:border-primary checked:after:content-['✓'] 
                      checked:after:text-white checked:after:flex checked:after:items-center checked:after:justify-center checked:after:h-full checked:after:w-full"
                />
                <span className={`flex-1`}>{opt["label"]}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2 lg:col-span-3 border border-gray-100 rounded-md p-4 flex flex-col overflow-auto shadow-sm">
          {checkMultiSelect && checkMultiSelect.length === 0
            ? Object.keys(data).map((category) => {
              const categoryNum = Number(
                Object.keys(categoryMap).find(
                  (key) => categoryMap[key] === category,
                ),
              );

              if (!data[category] || data[category].length === 0) return null;

              return (
                <div key={category} className="mb-6">
                  <h5 className="mb-4 font-medium">{category}</h5>
                  <div className="grid grid-cols-3 gap-4">
                    {data[category]?.map((item, idx) => {
                      const typeValue = item.type ?? idx + 1;
                      const isAdded = isIntegrationAdded(
                        categoryNum,
                        typeValue,
                      );

                      return (
                        <CardWithButton
                          key={`${category}-${idx}`}
                          title={item.title}
                          description={item.description}
                          category={categoryNum}
                          type={typeValue}
                          isAdded={isAdded}
                          onSetup={handleSetup}
                          onConfigure={handleConfigure}
                          buttonLoading={buttonLoading}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })
            : checkMultiSelect.map((numVal, index) => {
              const categoryName = categoryMap[numVal];

              if (!data[categoryName] || data[categoryName].length === 0)
                return null;

              return (
                <div className="mb-6" key={index}>
                  <h5 className="mb-4 font-medium">{categoryName}</h5>
                  <div className="grid grid-cols-3 gap-4">
                    {data[categoryName]?.map((item, idx) => {
                      const typeValue = item.type || idx + 1;
                      const isAdded = isIntegrationAdded(numVal, typeValue);

                      return (
                        <CardWithButton
                          key={idx}
                          title={item.title}
                          description={item.description}
                          category={numVal}
                          type={typeValue}
                          isAdded={isAdded}
                          onSetup={handleSetup}
                          onConfigure={handleConfigure}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

const Marketplace = () => {
  const isLogin = useSelector(selectIsAuthenticated);
  const currentUserDetails = useSelector((state) => state.auth.user) || {};
  const { portalValue, getDefaultRouteForCurrentPortal } = usePortalNavigation(
    isLogin,
    currentUserDetails,
  );

  const SettingsMenus = [
    {
      title: "Marketplace",
      page: <Integration />,
      type: "main",
      id: "marketplace_marketplace",
    },
  ];

  const filteredTabs = useModuleAccess({
    allTabs: SettingsMenus,
    parentId: "marketplace",
    accessKey: portalValue === "bs" ? "benchsales" : "ats",
  });

  return (
    <NewTab
      tabs={filteredTabs}
      color="black"
      variant="outlined"
      mode="url"
      tabId="marketplace"
    />
  );
};

export default Marketplace;
